module.exports = __webpack_public_path__ + "static/media/code-comparison.de7f2c36.png";